// @flow

export const ErrorsTypeList = [
  "email",
  "username",
  "password",
  "credentials",
  "attempts",
  "v1_change_password",
  "agree_check",
  "old_password",
  "new_password",
  "confirmation_code",
  "attempts_exceeded",
  "info_edit",
  "licence",
  "image",
  "company",
  "tags",
  "phone",
  "system",
  "form",
  "user",
  "facebase",
  "project",
  "quote",
  "reseller",
  "enduser",
  "billing"
];

export type ErrorsType = {
  email?: string,
  username?: string,
  password?: string,
  credentials?: string,
  attempts?: string,
  v1_change_password?: boolean,
  agree_check?: string,
  old_password?: string,
  new_password?: string,
  confirmation_code?: string,
  attempts_exceeded?: boolean,
  info_edit?: string,
  licence?: string,
  image?: string,
  company?: string,
  tags?: string,
  phone?: string,
  system?: string,
  form?: string,
  user?: string,
  facebase?: string,
  project?: string,
  quote?: string,
  reseller?: string,
  enduser?: string,
  billing?: string
};

export type PasswordStrengthType = {
  uppercase?: boolean,
  lowercase?: boolean,
  number?: boolean,
  length?: boolean,
  space?: boolean
};

export type UserFormType = {
  errors: ErrorsType,
  loading: boolean,
  email: string,
  password: string,
  password2: string,
  firstname: string,
  lastname: string,
  companyname: string,
  termsagreed: boolean,
  completed: boolean,
  passwordstrength: PasswordStrengthType,
  passwordDisplay?: boolean,
  oldpassword?: string
};